export default "__VITE_ASSET__Cm7DX0eW__"